import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../utilities/url";
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import { Controller, useForm } from "react-hook-form";
import { FaEye, FaPlus, FaRegFileExcel, FaTrash } from "react-icons/fa";
import CustomStyles from "../../components/customStyles";
import { ThemeContext } from "../../provider/themeContext";
import storage from "../../services/storage";
import CryptoJS from "crypto-js";
import "react-quill/dist/quill.snow.css";
import ModalDevice from "./component/addDevice";
import ModalShowRep from "./component/showRecipient";
import ModalAddRep from "./component/addRecipient";
import PanelContent from "./component/panelContent";
import { TiDocumentAdd } from "react-icons/ti";
import { format_number } from "../../utilities/ext-function";
import ModalDeleteRep from "./component/deleteRecepient";
import ExcelReader from "./component/excelReader";
import { Container, Form, Modal, Table } from "react-bootstrap";
import ScheduleConfiguration from "./component/scheduleConfiguration";
import moment from "moment";
import ConfirmRepModal from "./component/confirmRepModal";
import authService from "../../services/auth.service";
import { format } from "date-fns";

const DetailBroadcast = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const idBroadcast = CryptoJS.AES.decrypt(
    id.replace(/_/g, "/"),
    "wrs"
  ).toString(CryptoJS.enc.Utf8);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [hideSpiner, setHideSpiner] = useState(true);
  const [loading, setLoading] = useState(false);
  const dt_user = JSON.parse(localStorage.getItem("user"));
  const [device, setDevice] = useState([]);
  const [typeContact, setTypeContact] = useState("");
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [initStatus, setInitStatus] = useState(false);
  const submitActionRef = useRef("save");

  const [headers, setHeaders] = useState([]);
  const [file, setFile] = useState(null);

  const [showRepModal, setShowRepModal] = useState(false);
  const [deleteRepModal, setDeleteRepModal] = useState(false);
  const [addRepModal, setAddRepModal] = useState(false);
  const [selectedShowRep, setSelectedShowRep] = useState([]);
  const [selectedDeleteRep, setSelectedDeleteRep] = useState([]);

  // Panel Content
  const [allContent, setAllContent] = useState([
    {
      id: 0,
      name: "Default Variant",
      content: [
        {
          id: Date.now(),
          text: null,
          file: null,
        },
      ],
    },
  ]);

  // Schedule Configuration
  const [scheduleData, setScheduleData] = useState([]);

  const functionDropdown = [
    "First Name",
    "Last Name",
    "Title",
    "MSISDN",
    "Email",
    "Address",
    "Group",
  ];

  // Add Contact Broadcast
  const [filter, setFilter] = useState("contact");
  const [selectedRep, setSelectedRep] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get Broadcast
        const broadcastResponse = await axios.post(
          `${API_URL}get-broadcast`,
          { id: idBroadcast },
          {
            headers: {
              Authorization: `Bearer ${storage.get("access_token")}`,
            },
          }
        );
        if (broadcastResponse.data.success === true) {
          if (broadcastResponse.data.data.is_active == "Y") {
            // Pause Broadcast
            const pause = await axios.post(
              `${API_URL}update-status-broadcast`,
              { id: idBroadcast, is_active: "P" },
              {
                headers: {
                  Authorization: `Bearer ${storage.get("access_token")}`,
                },
              }
            );
            if (pause.data.success === true) {
              setInitStatus(true);
            }
          } else if (broadcastResponse.data.data.is_active == "P") {
            setInitStatus(true);
          }

          setValue("broadcastName", broadcastResponse.data.data.name);
          setValue("broadcastChannel", broadcastResponse.data.data.channel);
          setSelectedDevices(
            broadcastResponse.data.data.sender.map((item) => ({
              value: item.device.idt_device,
              label: `${item.device.name} (${item.device.msisdn})`,
            }))
          );
          setValue(
            "orderRep",
            broadcastResponse.data.data.is_randomized_target === "Y" ? 1 : 2
          );
          setSelectedContacts(
            broadcastResponse.data.data.target.map((item) => {
              const parsedData = JSON.parse(item.data || "{}");
              return {
                ...parsedData,
                Status: item.status === 0 ? "Ongoing" : "Success",
              };
            })
          );
          const newRep = {
            id: 0,
            name: `Contact ${broadcastResponse.data.data.target.length}`,
            contact: broadcastResponse.data.data.target.length,
            type: "excel",
          };

          setSelectedRep([newRep]);
          setValue("contentName", broadcastResponse.data.data.template.name);
          const parsedVariant = (
            broadcastResponse.data?.data?.template?.variant || []
          ).map((v, i) => {
            const parsedChatBubbles = (() => {
              try {
                return JSON.parse(v.chat_bubbles);
              } catch {
                return [];
              }
            })();

            return {
              id: i, // gunakan ID dari data
              name: v.name,
              content: parsedChatBubbles.map((c, index) => ({
                id: Date.now() + index, // bisa juga pakai `Date.now() + index` jika perlu unik
                text: c.content,
                file:
                  c.media_type !== "text"
                    ? {
                        name: index,
                        url: c.media_url,
                        type: c.media_type + "/",
                      }
                    : null,
              })),
            };
          });
          setAllContent(parsedVariant);
          const dayMap = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          const parsedSchedule = (
            broadcastResponse.data?.data?.schedule || []
          ).map((item) => {
            const repetition = item.schedule_repetition ?? 0;
            let setting;

            if (repetition === 1) {
              const day = dayMap[Number(item.schedule_setting)] ?? "Sunday";
              setting = {
                value: day, // contoh: "1"
                label: day, // contoh: "Monday"
              };
            } else if (repetition === 2) {
              // Monthly: backend kirim angka (1–31)
              const value = String(item.schedule_setting);
              setting = { value, label: value };
            } else if (repetition === 3) {
              // Specific date: tanggal format DD-MM
              setting = {
                value: format(item.schedule_setting_ddmm, "d-MMM"),
                label: format(item.schedule_setting_ddmm, "d-MMM"),
              };
            } else {
              // No repetition or unknown
              setting = item.schedule_setting;
            }

            return {
              repetition,
              setting,
              startHour: item.hour_start,
              endHour: item.hour_end,
              startDate: moment(item.date_start).toString(),
              endDate: moment(item.date_end).toString(),
              estimate_cap: item.estimate_cap ?? null,
            };
          });

          setScheduleData(parsedSchedule);
          setLoading(false);
        }
      } catch (error) {
        if (error.response.data.message) {
          authService.logout();
        }
      }
    };

    fetchData();
  }, []);

  /* Modal */
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;

  const totalPages = Math.ceil(selectedContacts.length / ITEMS_PER_PAGE);
  const paginatedData = selectedContacts.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSelectedDevices = (newSelectedData) => {
    setSelectedDevices(newSelectedData);
    setValue("broadcastDevice", newSelectedData);
    clearErrors("broadcastDevice");
  };
  const handleSelectedDataChange = (newSelectedData) => {
    // Ambil data kontak yang dipilih
    const newContacts = newSelectedData
      .filter((item) => item.type === "contact")
      .flatMap((item) => item.data);

    // Hapus duplikasi dalam newContacts
    const uniqueContacts = newContacts.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (t) => t.name_first === item.name_first && t.msisdn === item.msisdn
        )
    );

    // Ambil data grup yang dipilih
    const newGroups = newSelectedData
      .filter((item) => item.type === "group")
      .flatMap((item) => item.data);

    // Hapus duplikasi dalam newGroups
    const uniqueGroups = newGroups.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.name === item.name)
    );

    // Perbarui selectedContacts (gunakan callback untuk sinkronisasi)
    setSelectedContacts((prev) => {
      const updatedContacts = uniqueContacts;
      updateSelectedRep(updatedContacts, selectedGroups);
      return updatedContacts;
    });

    // Perbarui selectedGroups (gunakan callback untuk sinkronisasi)
    setSelectedGroups((prev) => {
      const updatedGroups = uniqueGroups;
      updateSelectedRep(selectedContacts, updatedGroups);
      return updatedGroups;
    });
  };

  // Fungsi pembantu untuk memperbarui selectedRep
  const updateSelectedRep = (contacts, groups) => {
    setSelectedRep(() => {
      let updatedRep = [];

      // Jika ada kontak yang dipilih, tambahkan ke selectedRep
      if (contacts.length > 0) {
        updatedRep.push({
          id: 0,
          name: `Selected Contacts (${contacts.length})`,
          contact: contacts.length,
          type: "contacts",
        });
      }

      // Jika ada grup yang dipilih, tambahkan ke selectedRep
      groups.forEach((group) => {
        updatedRep.push({
          id: group.idt_contact_group,
          name: group.name || "Unnamed Group",
          contact: group.total_contacts || 0,
          type: "groups",
        });
      });

      return updatedRep;
    });
  };

  const handleDeleteDataChange = (updatedContacts, deletedGroupId = null) => {
    // Jika tidak ada kontak, kosongkan selectedContacts
    setSelectedContacts(updatedContacts.length === 0 ? [] : updatedContacts);

    setSelectedGroups((prevGroups) => {
      let updatedGroups = prevGroups;

      // Jika ada grup yang dihapus, hapus dari selectedGroups
      if (deletedGroupId) {
        updatedGroups = prevGroups.filter(
          (group) => group.idt_contact_group !== deletedGroupId
        );
      }

      // Jika tidak ada kontak & grup, kosongkan selectedRep
      if (updatedContacts.length === 0 && updatedGroups.length === 0) {
        setSelectedRep([]);
        return [];
      }

      // Perbarui selectedRep
      setSelectedRep((prevSelectedRep) => {
        let updatedRep = prevSelectedRep.filter(
          (item) =>
            !item.name.startsWith("Selected Contacts") && // Hapus "Selected Contacts"
            (deletedGroupId ? item.id !== deletedGroupId : true) // Hapus grup yang dihapus
        );

        // Jika masih ada kontak tersisa, tambahkan kembali "Selected Contacts"
        if (updatedContacts.length > 0) {
          updatedRep.unshift({
            id: 0,
            name: `Selected Contacts (${updatedContacts.length})`,
            contact: updatedContacts.length,
            type: "contacts",
          });
        }

        return updatedRep;
      });

      return updatedGroups;
    });
  };

  const handleDeleteRepChange = (updatedData) => {
    if (updatedData.id) {
      setSelectedRep((prevSelectedRep) =>
        prevSelectedRep.filter((rep) => rep.id !== updatedData.id)
      );
      setSelectedGroups((prevGroups) =>
        prevGroups.filter((group) => group.idt_contact_group !== updatedData.id)
      );
    } else {
      setSelectedRep((prevSelectedRep) =>
        prevSelectedRep.filter((rep) => rep.id !== 0)
      );
      setSelectedContacts([]);
    }
  };

  // Draged Rep
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDrop = (index) => {
    if (draggedIndex === null) return;
    const newList = [...selectedRep];
    const draggedItem = newList.splice(draggedIndex, 1)[0]; // Ambil elemen yang di-drag
    newList.splice(index, 0, draggedItem); // Masukkan di posisi baru
    setSelectedRep(newList);
    setDraggedIndex(null);
  };

  const handleShowRep = (item, type) => {
    if (type === "contacts") {
      setSelectedShowRep(item);
      setShowRepModal(true);
      setTypeContact(type);
    } else {
      axios
        .post(
          API_URL + "contact-list",
          {
            idt_workspace: workspace.idt_user_workspace,
            idt_contact_group: item,
          },
          {
            headers: { Authorization: `Bearer ${storage.get("access_token")}` },
          }
        )
        .then((response) => {
          if (response.data.success) {
            setSelectedShowRep(response.data.data);
          } else {
            setSelectedShowRep([]);
          }
          setTypeContact(type);
          setShowRepModal(true);
        })
        .catch((error) => {
          if (error.response.data.message) {
            authService.logout();
          }
        });
    }
  };

  const handleDeleteRep = (item) => {
    setSelectedDeleteRep(item);
    setDeleteRepModal(true);
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    formState: { errors },
    clearErrors,
    setValue,
  } = useForm({
    reValidateMode: "onBlur",
  });

  const sourceRep = watch("sourceRep");
  const broadcastChannelValue = watch("broadcastChannel");

  useEffect(() => {
    if (!broadcastChannelValue) {
      reset({ sourceRep: "" }); // Reset nilai sourceRep jika channel belum dipilih
    } else {
      // Get Device
      axios
        .post(
          `${API_URL}list-device-all`,
          {
            idt_workspace: workspace.idt_user_workspace,
            type: broadcastChannelValue,
          },
          {
            headers: {
              Authorization: `Bearer ${storage.get("access_token")}`,
            },
          }
        )
        .then((response) => {
          if (response.data.success === true) {
            const maps = response.data.data.map(function (d) {
              const map = {
                value: d.idt_device,
                label: d.name + " (" + d.msisdn + ")",
                name: d.name,
                msisdn: d.msisdn,
                quota: d.quota,
                min_period: d.min_sending_period,
                max_period: d.max_sending_period,
                type: d.type_device,
                osa_name: d.osa_name,
              };
              return map;
            });
            setDevice(maps);
          } else {
            setDevice([]);
          }
        })
        .catch((error) => {
          if (error.response.data.message) {
            authService.logout();
          }
        });
    }
  }, [broadcastChannelValue, reset]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(() => () => {});
  const [pendingSourceRep, setPendingSourceRep] = useState(null);
  const handleSourceRepChange = (e) => {
    const newSourceRep = e.target.value;
    if (newSourceRep === "1") {
      if (file) {
        setPendingSourceRep(newSourceRep);
        setConfirmAction(() => () => {
          setFile(null);
          setSelectedContacts([]);
          setSelectedGroups([]);
          setSelectedRep([]);
          setValue("sourceRep", newSourceRep); // Update setelah konfirmasi
          setShowConfirmModal(false);
          setPendingSourceRep(null);
          setValue("recipientTarget", null);
        });
        setShowConfirmModal(true);
      } else {
        setSelectedContacts([]);
        setSelectedGroups([]);
        setSelectedRep([]);
        setValue("recipientTarget", null);
        setValue("sourceRep", newSourceRep);
      }
    } else if (newSourceRep === "2") {
      if (selectedRep.length > 0) {
        setPendingSourceRep(newSourceRep);
        setConfirmAction(() => () => {
          setSelectedContacts([]);
          setSelectedGroups([]);
          setSelectedRep([]);
          setValue("sourceRep", newSourceRep); // Update setelah konfirmasi
          setShowConfirmModal(false);
          setPendingSourceRep(null);
          setValue("recipientTarget", null);
        });
        setShowConfirmModal(true);
      } else {
        setFile(null);
        setValue("recipientTarget", null);
        setValue("sourceRep", newSourceRep);
      }
    } else if (!newSourceRep) {
      if (file || selectedRep.length > 0) {
        setPendingSourceRep(newSourceRep);
        setConfirmAction(() => () => {
          setFile(null);
          setSelectedContacts([]);
          setSelectedGroups([]);
          setSelectedRep([]);
          setValue("sourceRep", newSourceRep);
          setShowConfirmModal(false);
          setPendingSourceRep(null);
          setValue("recipientTarget", null);
        });
        setShowConfirmModal(true);
      } else {
        setFile(null);
        setSelectedContacts([]);
        setSelectedGroups([]);
        setSelectedRep([]);
        setValue("recipientTarget", null);
        setValue("sourceRep", newSourceRep);
      }
    }
  };

  const handleRecipientTargetChange = (e) => {
    setValue("recipientTarget", e.target.value);
  };

  const onSubmit = (data) => {
    const formData = new FormData();

    const action = submitActionRef.current;

    if (action === "saverun") {
      formData.append("is_active", "Y");
    }

    // Kirim data teks sebagai JSON string
    formData.append("idt_broadcast_campaign", idBroadcast);
    formData.append("idt_user_workspace", workspace.idt_user_workspace);
    formData.append("name", data.broadcastName);
    // formData.append("channel", data.broadcastChannel);
    // formData.append("device", JSON.stringify(data.broadcastDevice));
    formData.append("order", data.orderRep);
    // formData.append("contactData", JSON.stringify(selectedContacts));
    // formData.append("groupData", JSON.stringify(selectedRep));
    formData.append("sourceRep", data.sourceRep);
    formData.append("contentName", data.contentName);
    formData.append("scheduleData", JSON.stringify(scheduleData));
    // formData.append("recipientTarget", data.recipientTarget);
    // if (data.sourceRep === 1) {
    //   formData.append(
    //     "target_total",
    //     selectedRep.reduce((acc, item) => acc + item.contact, 0)
    //   );
    // } else {
    //   formData.append("target_total", selectedContacts.length);
    // }

    // Ubah `contentData` agar hanya mengirim metadata, file dikirim terpisah
    const contentData = allContent.map((content) => ({
      id: content.id,
      name: content.name,
      content: content.content.map((item) => {
        let mediaType = "text"; // Default jika tidak ada file

        if (item.file) {
          const fileType = item.file.type.split("/")[0]; // Ambil kategori MIME type
          if (["audio", "video", "image"].includes(fileType)) {
            mediaType = fileType; // Set mediaType sesuai kategori
          } else {
            mediaType = "file"; // Jika bukan audio, video, atau image
          }
        }

        return {
          text: item.text,
          media_type: mediaType, // Ganti dari "value" ke "media_type"
          file: item.file ? item.file.name : null, // Simpan hanya nama file
        };
      }),
    }));

    formData.append("contentData", JSON.stringify(contentData)); // Kirim tanpa file

    // **Tambahkan file ke FormData sebagai array**
    let fileCount = 0;
    allContent.forEach((content) => {
      content.content.forEach((item) => {
        if (item.file) {
          console.log(`Menambahkan file: ${item.file.name}`);
          formData.append("files[]", item.file); // Gunakan "files[]" untuk multiple files
          fileCount++;
        }
      });
    });

    // for (let pair of formData.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    axios
      .post(`${API_URL}update-broadcast`, formData, {
        headers: {
          Authorization: `Bearer ${storage.get("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          localStorage.setItem("alertu", true);
          navigate("/broadcast");
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const [isModalDeviceOpen, setIsModalDeviceOpen] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileReset = () => {
    setFile(null); // Reset state file
    setValue("recipientTarget", null);
    document.querySelector(".uploadFile").value = ""; // Reset input file
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    // Cek apakah file ada
    if (!selectedFile) return;

    // Ambil ekstensi file dengan cara lebih aman
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    const validExtensions = ["xls", "xlsx"];

    if (!validExtensions.includes(fileExtension)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed!", {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
      });

      // Reset input file (agar bisa upload file yang sama lagi)
      event.target.value = "";
      return;
    }

    // Reset file sebelum menyimpan yang baru
    setFile(null);
    setTimeout(() => {
      setFile(selectedFile);
    }, 0);
  };

  // Tambah baris baru
  const addRow = () => {
    setScheduleData([
      ...scheduleData,
      {
        repetition: 0,
        setting: null,
        startHour: moment().startOf("day").format("HH:mm"),
        endHour: moment().startOf("day").add(23, "hours").format("HH:mm"),
        startDate: moment().toString(),
        endDate: moment().add(1, "day").toString(),
        estimate_cap: null,
      },
    ]);
  };

  // Hapus baris
  const removeRow = (index) => {
    setScheduleData(scheduleData.filter((_, i) => i !== index));
  };

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <div className="col-auto">
          <h5>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/broadcast">Broadcast</Link>
                </li>
                <li className="breadcrumb-item active">Detail Broadcast</li>
              </ol>
            </nav>
          </h5>
        </div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12 mx-auto">
          <div className="card rounded-4 shadow-lg">
            <div className="card-header rounded-4">
              <h5 className="card-title text-center">Detail Broadcast</h5>
              <ToastContainer />
            </div>
            <div className="card-body">
              <div className="card-body h-100">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="circle-number-container mb-4">
                        <div className="circle-number">1</div>
                        <div className="circle-text">
                          <span className="main-text">Broadcast Setting</span>
                          <span className="sub-text">
                            Fill in the broadcast name and assistant to be used.
                          </span>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-form-label col-sm-3 text-sm-right">
                          Broadcast Name
                          <span className="required">*</span>
                        </label>
                        <div className="col-sm-4 error-placeholder">
                          <input
                            type="text"
                            {...register("broadcastName", {
                              required: "Broadcast Name is required",
                            })}
                            className={`form-control ${
                              errors.broadcastName ? "is-invalid" : ""
                            }`}
                          />
                          {errors.broadcastName && (
                            <div className="invalid-feedback">
                              {errors.broadcastName.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-form-label col-sm-3 text-sm-right">
                          Broadcast Channel
                          <span className="required">*</span>
                        </label>
                        <div className="col-sm-4 error-placeholder">
                          <select
                            {...register("broadcastChannel", {
                              required: "Broadcast Channel is required",
                            })}
                            className={`form-select ${
                              errors.broadcastChannel ? "is-invalid" : ""
                            }`}
                            disabled
                          >
                            <option value="">Select Channel</option>
                            <option value="WHATSAPP">Whatsapp </option>
                            <option value="TELEGRAM">Telegram</option>
                            <option value="LINE">LINE</option>
                            <option value="EMAIL">Email</option>
                          </select>
                          {errors.broadcastChannel && (
                            <div className="invalid-feedback">
                              {errors.broadcastChannel.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-form-label col-sm-3 text-sm-right">
                          Broadcast Device
                        </label>
                        <div className="col-sm-4 error-placeholder">
                          <Controller
                            name="broadcastDevice"
                            control={control}
                            className={`${
                              errors.broadcastDevice ? "is-invalid" : ""
                            }`}
                            render={({ field }) => (
                              <>
                                <Select
                                  {...field}
                                  isMulti
                                  styles={CustomStyles(theme)}
                                  className="custom-select"
                                  maxMenuHeight={200}
                                  options={device}
                                  value={selectedDevices}
                                  placeholder="Select Device"
                                  onBlur={field.onBlur}
                                  onChange={(selected) => {
                                    setSelectedDevices(selected);
                                    field.onChange(selected);
                                    clearErrors("broadcastDevice");
                                  }}
                                  isClearable={false} // Tidak bisa dihapus langsung
                                  isSearchable={false} // Tidak bisa mencari
                                  menuIsOpen={false}
                                  components={{
                                    IndicatorsContainer: () => null,
                                  }}
                                  isDisabled
                                />
                              </>
                            )}
                          />
                          {errors.broadcastDevice && (
                            <p className="errorMsg text-danger fs-7">
                              {errors.broadcastDevice.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="circle-number-container mb-4">
                        <div className="circle-number">2</div>
                        <div className="circle-text">
                          <span className="main-text">Recipient's purpose</span>
                          <span className="sub-text">
                            Fill define specific recipient and order broadcast.
                          </span>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-form-label col-sm-3 text-sm-right">
                          Order of Recipient
                          <span className="required">*</span>
                        </label>
                        <div className="col-sm-4 error-placeholder">
                          <select
                            {...register("orderRep", {
                              required: "Order is required",
                            })}
                            className={`form-select ${
                              errors.orderRep ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select Order</option>
                            <option value="1">Randomized</option>
                            <option value="2">Ordered</option>
                          </select>
                          {errors.orderRep && (
                            <div className="invalid-feedback">
                              {errors.orderRep.message}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Recipient Filter Type
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-4 error-placeholder">
                            <select
                              {...register("filterRep", {
                                required: "Recipient Filter is required",
                              })}
                              className={`form-select ${
                                errors.filterRep ? "is-invalid" : ""
                              }`}
                            >
                              <option value="">Select Filter</option>
                              <option value="1">By Contact</option>
                              <option value="2">By Contact Group</option>
                            </select>
                            {errors.filterRep && (
                              <div className="invalid-feedback">
                                {errors.filterRep.message}
                              </div>
                            )}
                          </div>
                        </div> */}
                      <div className="mb-3 row">
                        <label className="col-form-label col-sm-3 text-sm-right">
                          Recipient Setting
                        </label>
                        <div className="col-sm-4 error-placeholder">
                          <div className="table-responsive">
                            <table className="table table-striped table-bordered table-custome w-100 mb-0">
                              <thead>
                                <tr className="text-white">
                                  <th
                                    className="text-center p-2"
                                    style={{ width: "15%" }}
                                  >
                                    Total Data
                                  </th>
                                  <th
                                    className="text-center p-2"
                                    style={{ width: "13%" }}
                                  >
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center p-2">
                                    {selectedContacts.length} data
                                  </td>
                                  <td className="text-center p-2">
                                    <Button
                                      variant="primary"
                                      size="sm"
                                      onClick={() => {
                                        // setCurrentPage(1);
                                        setShowModal(true);
                                      }}
                                    >
                                      <FaEye size={14} />
                                    </Button>{" "}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="circle-number-container mb-4">
                        <div className="circle-number">3</div>
                        <div className="circle-text">
                          <span className="main-text">Broadcast Content</span>
                          <span className="sub-text">
                            Fill in the content to be used.
                          </span>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-form-label col-sm-3 text-sm-right">
                          Content Name
                          <span className="required">*</span>
                        </label>
                        <div className="col-sm-4 error-placeholder">
                          <input
                            type="text"
                            {...register("contentName", {
                              required: "Content is required",
                            })}
                            className={`form-control ${
                              errors.contentName ? "is-invalid" : ""
                            }`}
                          />
                          {errors.contentName && (
                            <div className="invalid-feedback">
                              {errors.contentName.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-md-12">
                          <PanelContent
                            allContent={allContent}
                            setAllContent={setAllContent}
                            headers={headers}
                            selectedRep={selectedRep}
                            functionDropdown={functionDropdown}
                          />
                        </div>
                      </div>
                      {/* <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Chatbot Knowledge
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <textarea
                              {...register("chatbotKnowledge")}
                              className={`form-control ${
                                errors.chatbotKnowledge ? "is-invalid" : ""
                              }`}
                              rows={10}
                            />
                            {errors.chatbotKnowledge && (
                              <div className="invalid-feedback">
                                {errors.chatbotKnowledge.message}
                              </div>
                            )}
                          </div>
                        </div> */}
                      <hr />
                      <div className="circle-number-container mb-4">
                        <div className="circle-number">4</div>
                        <div className="circle-text">
                          <span className="main-text">
                            Delivery Schedule Configuration
                          </span>
                          <span className="sub-text">
                            Fill delivery schedule configuration to be used.
                          </span>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-md-12">
                          <ScheduleConfiguration
                            scheduleData={scheduleData}
                            setScheduleData={setScheduleData}
                            removeRow={removeRow}
                          />
                        </div>
                        <div className="">
                          <a onClick={addRow} className="btn btn-primary">
                            <FaPlus /> Add Schedule
                          </a>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                  {/* <hr className="mb-4"></hr> */}
                  <div className="mt-4">
                    <Link to="/broadcast" className="btn btn-danger btn-md">
                      Cancel
                    </Link>
                    {initStatus && (
                      <button
                        type="submit"
                        className="btn btn-success btn-md float-end"
                        onClick={() => (submitActionRef.current = "saverun")}
                      >
                        <span
                          className={`spinner-border spinner-border-xs me-2 ${
                            hideSpiner ? "d-none" : ""
                          }`}
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Update & Run
                      </button>
                    )}
                    <button
                      type="submit"
                      className="btn btn-info btn-md float-end me-2"
                      onClick={() => (submitActionRef.current = "save")}
                    >
                      <span
                        className={`spinner-border spinner-border-xs me-2 ${
                          hideSpiner ? "d-none" : ""
                        }`}
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tampilkan Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Selected Contacts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table
              className="table table-striped table-bordered table-custome"
              bordered
            >
              <thead>
                <tr
                  className="text-white"
                  style={{ backgroundColor: "#13213c" }}
                >
                  {paginatedData.length > 0 &&
                    Object.keys(paginatedData[0]).map((key, idx) => (
                      <th key={idx} className="text-center p-2">
                        {key}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((contact, i) => (
                  <tr key={i}>
                    {Object.values(contact).map((value, j) => (
                      <td key={j} className="text-center p-2">
                        {value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Page {currentPage} of {totalPages}
            </div>
            {totalPages > 1 && (
              <div>
                <Button
                  size="sm"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="me-2"
                >
                  Prev
                </Button>
                <Button
                  size="sm"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </Button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/* <ModalDevice
        show={isModalDeviceOpen}
        handleClose={() => setIsModalDeviceOpen(false)}
        device={device}
        selectedDevices={selectedDevices}
        onChanged={handleSelectedDevices}
      />
      <ModalShowRep
        show={showRepModal}
        handleClose={() => setShowRepModal(false)}
        type={typeContact}
        data={selectedShowRep}
        onDeleteChange={handleDeleteDataChange}
      />
      <ModalAddRep
        show={addRepModal}
        filter={filter}
        setFilter={setFilter}
        selectedContacts={selectedContacts}
        setSelectedContacts={setSelectedContacts}
        selectedGroups={selectedGroups}
        setSelectedGroups={setSelectedGroups}
        handleClose={() => setAddRepModal(false)}
        onSelectedDataChange={handleSelectedDataChange}
      />
      <ModalDeleteRep
        show={deleteRepModal}
        handleClose={() => setDeleteRepModal(false)}
        data={selectedDeleteRep}
        onDeleteChange={handleDeleteRepChange}
      />
      <ConfirmRepModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        handleConfirm={confirmAction}
      /> */}
    </div>
  );
};

export default DetailBroadcast;
